module.exports = __webpack_public_path__ + "static/media/webpromo_logo.ee3be21a.png";